import { Box } from '@chakra-ui/react';
import EventGridCarousel from 'presentation/components/modules/events/grid/EventGridCarousel';
import ArticleCommentsContainer from 'presentation/containers/modules/community/ArticleCommentsContainer';
import PrivateChannelDetailCardContainer from 'presentation/containers/modules/community/PrivateChannelDetailCardContainer';
import PrivateChannelLayout from 'presentation/layout/modules/privateChannel/PrivateChannelLayout';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import {
  useFetchPassedEventsQuery,
  useFetchUpcomingEventsQuery,
} from 'rtkQuery/sharespro/queries/events';

const ArticleCommentsPage: FC = () => {
  const { id: articleId, isCommentable: isComment } = useParams();
  const isCommentable = isComment !== 'false';
  const { t } = useTranslation();

  const { data: passedEvents } = useFetchPassedEventsQuery();

  const { data: upcomingEvents } = useFetchUpcomingEventsQuery();

  return (

    <PrivateChannelLayout>
      <PrivateChannelDetailCardContainer/>
      <Box h="20px" />
      {articleId && <ArticleCommentsContainer articleId={+articleId} isCommentable={isCommentable}/>}
      <Box h="20px" />
      {upcomingEvents && (
        <Box mt="20px">
          <EventGridCarousel
            events={upcomingEvents.items}
            title={t('nextEvents')}
          />
        </Box>
      )}
      {passedEvents && (
        <Box mt="20px">
          <EventGridCarousel
            events={passedEvents.items}
            title={t('prevEvents')}
          />
        </Box>
      )}
    </PrivateChannelLayout>
  );
};

export default ArticleCommentsPage;
